module.exports = __webpack_public_path__ + "img/svg/result-winner-trophy.565078c1c8f27f96b13defd4226acadb.svg";